import { render } from "./HeroiconsOutlineAtSymbol.vue?vue&type=template&id=68b5e2af"
const script = {}

import exportComponent from "/var/www/web/driving-school-be/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineAtSymbol.vue"]])

export default __exports__